<template>
    <span>
        <!-- <span style="margin-right: 25px;" v-if="accounts.length <= 1"> {{ active_account.department.title }}</span> -->
        <el-dropdown v-if="accounts.length > 1" class="item" trigger="click" @command="changeAccount">
            <span class="el-dropdown-link" style="color: #ffffff; cursor: pointer;">
                <span v-if="active_account && active_account.hasOwnProperty('department')">
                    {{ active_account.department.title }}
                </span>
                <i class="el-icon-arrow-down el-icon--right"></i>
            </span>

            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="accounts.length > 5">
                    <el-input 
                        :placeholder="$t('topbar.search_departments_placeholder')"
                        v-model="department_query"
                        @click.native.stop=""
                        size="mini"
                    >
                    </el-input>
                </el-dropdown-item>

                <el-dropdown-item v-for="account in computedAccounts"
                    :key="account.id"
                    :command="account"
                    v-bind:class="{ activeDepartment : account.active }"
                >

                   {{ account.department.title }}

                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </span>
</template>

<script>
import Axios from 'axios';
import handleCookies from '@/mixins/handle-cookies.js';

export default {
        props: ['active_account'],

        mixins: [handleCookies],

        data() {
            return {
                search_threshold: 10,
                accounts: [],
                department_query: '',
                selected_account: {}
            }
        },

        created() {
            this.getAccounts();
            this.selected_account = this.active_account;
        },

        computed: {
            computedAccounts() {
              return this.accounts.filter(account => {
                  return account.department.title.toLowerCase().includes(this.department_query.toLowerCase());
                });
            }
        },

        methods: {
            getAccounts() {
                let token = this.$cookies.get('bs_token');

                Axios.get('https://api.brandsafe.no/v1/profile/accounts', { headers: { 'Authorization': 'Bearer ' + token } }).then((response) => {
                    this.accounts = response.data.data;

                    this.accounts.forEach(account => {
                        if (account.active) {
                            if (this.active_account && this.active_account.hasOwnProperty('id') && this.active_account.id !== account.id) {
                                location.reload();
                            }
                        }
                    });
                }, (error) => {
                    this.accounts = [];
                });
            },

            changeAccount(account) {
                if (account.id === this.active_account.id) {
                  return false;
                }

                Axios.post('https://api.brandsafe.no/v1/profile/accounts',
                    {id: account.id},
                    {headers: {'Authorization': 'Bearer ' + this.$cookies.get('bs_token')}}
                ).then(async response => {
                    let data = response.data.data;

                    let cookies = [
                        {
                            key: 'bs_language',
                            value: data.language 
                        },
                        {
                            key: 'bs_role',
                            value: data.role.title
                        },
                        {
                            key: 'bs_profile',
                            value: data.profile
                        },
                        {
                            key: 'bs_active_department_id',
                            value: data.department.id
                        },
                        {
                            key: 'bs_active_customer_id',
                            value: data.customer.id
                        }
                    ];

                    await this.setCookies(cookies);

                    this.$nextTick(() => {
                        location.reload();
                    });
                }, (error) => {
                    alert('could_not_change_department');
                });
            }
        }
    }
</script>

<style lang="less" scoped>
    .el-dropdown-menu {
        top: 0 !important;
        max-height: 90vh !important;
        overflow: auto !important; 
    }
</style>
